import React, { PureComponent } from 'react';

import Icon from  './icon';

const WIDTH = 1;
const HEIGHT = 1;

const Element = ({ className, getSize, color, style }) => (
    <svg className={className} style={style} width={getSize(WIDTH)} height={getSize(HEIGHT)} viewBox="0 0 18 18" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <path d="M18 8.983c.01 4.959-4.088 9.014-9.111 9.017a9.151 9.151 0 01-6.118-2.32.432.432 0 01-.016-.632l.623-.615a.447.447 0 01.609-.015 7.382 7.382 0 004.895 1.84c4.065 0 7.353-3.247 7.353-7.258 0-4.012-3.29-7.258-7.353-7.258a7.38 7.38 0 00-5.218 2.143L5.47 5.642a.435.435 0 01-.31.745H.441A.438.438 0 010 5.952V1.359c0-.387.472-.582.751-.31l1.658 1.614A9.148 9.148 0 018.882 0c5.03 0 9.109 4.02 9.118 8.983zm-6.142 3.272l.519-.704a.432.432 0 00-.097-.608L9.764 9.137V3.92a.438.438 0 00-.44-.435H8.44a.438.438 0 00-.44.434v6.105l3.242 2.327a.445.445 0 00.616-.096z" fill={color} />
    </svg>
)

export default class IconHistory extends PureComponent {
    render() {
        return <Icon color={this.props.color} size={this.props.size} style={this.props.style} baseline={this.props.baseline} className={this.props.className}><Element /></Icon>;
    }
}
